import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '@root/firebase';

const COLORS = {
  verified: { color: 'success', label: 'Verified' },
  pending: { color: 'info', label: 'Pending' },
  rejected: { color: 'danger', label: 'Rejected' },
  none: { color: 'warning', label: 'Unverified' },
};

export default function VerifiedBadge({ productId, compact = false }) {
  const [status, setStatus] = useState('none');

  useEffect(() => {
    if (!productId) return;
    const unsub = onSnapshot(doc(db, 'marketplace', productId), (snap) => {
      const data = snap.data();
      setStatus(data?.verificationStatus || 'none');
    });
    return () => unsub?.();
  }, [productId]);

  const s = COLORS[status] || COLORS.none;

  return <a className={`badge badge-${s.color}`}>{s.label}</a>;
}
